<template>
    <div class="container-outline">
        <div class="register">
            <div class="title">Register</div>
            <div class="top-squence">
                <head-register :dataSquence="{ id: 9, title: 'lampiran' }" />
            </div>
            <div class="content-register">
                <div class="container">
                    <div class="sub-title">
                        <div>Lampiran</div>
                        <div class="warning-size">
                            <b-icon icon="info-fill" class="info-warning"></b-icon>
                            Pastikan semua file gambar dengan format .jpeg atau .png dan maksimal 400kb
                        </div>
                    </div>
                    <form @submit.prevent="registerKYC" enctype="multipart/form-data">
                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto Rekening Koran Bank/Tagihan Kartu Kredit *</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingRekBank">{{ label_rekBank }}</span>
                                    <span v-else><b-spinner small class="text-right"></b-spinner></span>
                                    <input type="file" class="form-input input-file" ref="rekBank" @change="onFileRekBank" accept="image/jpeg,image/png" />
                                </label>
                                <div v-if="$v.file.recent_photo_file.$error">
                                    <div class="error size-image" v-if="!$v.file.recent_photo_file.required">
                                        Upload Foto Rekening tidak boleh kosong
                                    </div>
                                </div>
                                <div class="error size-image" v-show="statusImg == 3">
                                    Format file atau ukuran salah
                                </div>
                            </div>
                        </div>
                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto Rekening Listrik/Telepon *</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingRek">{{ label_listrik }}</span>
                                    <span v-else><b-spinner small class="text-right"></b-spinner></span>
                                    <input type="file" class="form-input input-file" ref="listrik" @change="onFileRek" accept="image/jpeg,image/png" />
                                </label>
                                <div v-if="$v.file.recent_photo_file.$error">
                                    <div class="error size-image" v-if="!$v.file.recent_photo_file.required">
                                        Upload Foto Rekening tidak boleh kosong
                                    </div>
                                </div>
                                <div class="error size-image" v-show="statusImg == 3">
                                    Format file atau ukuran salah
                                </div>
                            </div>
                        </div>

                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto diri dengan ktp *</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingPicKtp">{{ label_foto_Ktp }}</span>
                                    <span v-else><b-spinner small class="text-right"></b-spinner></span>
                                    <input type="file" class="form-input input-file" ref="diri_ktp" @change="onFileKTPterkini" accept="image/jpeg,image/png" />
                                </label>
                                <div v-if="$v.file.pict_with_ktp_file.$error">
                                    <div class="error size-image" v-if="!$v.file.pict_with_ktp_file.required">
                                        Upload diri dengan ktp tidak boleh kosong
                                    </div>
                                </div>
                                <div class="error size-image" v-show="statusImg == 4">
                                    Format file atau ukuran salah
                                </div>
                            </div>
                        </div>
                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto terkini *</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingPict">{{ label_terkini }}</span>
                                    <span v-else><b-spinner small class="text-right"></b-spinner></span>
                                    <input type="file" class="form-input input-file" ref="terkini" @change="onFileterkini" accept="image/jpeg,image/png" />
                                </label>
                                <div v-if="$v.file.recent_photo_file.$error">
                                    <div class="error size-image" v-if="!$v.file.recent_photo_file.required">
                                        Upload Foto Terkini tidak boleh kosong
                                    </div>
                                </div>
                                <div class="error size-image" v-show="statusImg == 3">
                                    Format file atau ukuran salah
                                </div>
                            </div>
                        </div>
                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto/scan KTP *</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingKtp">
                                        {{ label_ktp }}
                                    </span>
                                    <span v-else>
                                        <b-spinner small class="text-right"></b-spinner>
                                    </span>
                                    <input type="file" class="form-input input-file" ref="ktp" @change="onFileKTP" accept="image/jpeg,image/png" />
                                </label>
                                <div class="error size-image" v-show="statusImg == 1">
                                    Format file atau ukuran salah
                                </div>
                                <div v-if="$v.file.ktp_file.$error">
                                    <div class="error size-image" v-if="!$v.file.ktp_file.required">
                                        Upload KTP tidak boleh kosong
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto/scan NPWP</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingNpwp">{{ label_npwp }}</span>
                                    <span v-else><b-spinner small class="text-right"></b-spinner></span>
                                    <input type="file" class="form-input input-file" ref="npwp" @change="onFileNPWP" accept="image/jpeg,image/png" />
                                </label>
                                <div v-if="$v.file.file_npwp.$error">
                                    <div class="error size-image" v-if="!$v.file.file_npwp.required">
                                        Upload NPWP tidak boleh kosong
                                    </div>
                                </div>
                                <div class="error size-image" v-show="statusImg == 2">
                                    Format file atau ukuran salah
                                </div>
                            </div>
                        </div>
                        <div class="form-group group-file">
                            <label for="" class="label-file">Foto Kartu Keluarga</label>
                            <div class="wrap-label">
                                <label class="label-upload" data-browse="Upload file">
                                    <span v-if="!loadingKK">{{ label_kk }}</span>
                                    <span v-else><b-spinner small class="text-right"></b-spinner></span>
                                    <input type="file" class="form-input input-file" ref="bank" @change="onFileKK" accept="image/jpeg,image/png" />
                                </label>
                                <div v-if="$v.file.pict_with_ktp_file.$error">
                                    <div class="error size-image" v-if="!$v.file.pict_with_ktp_file.required">
                                        Upload Kartu Keluarga tidak boleh kosong
                                    </div>
                                </div>
                                <div class="error size-image" v-show="statusImg == 4">
                                    Format file atau ukuran salah
                                </div>
                            </div>
                        </div>
                        <div class="form-group group-file">
                            <label for="" class="label-file">Video Pernyataan *</label>
                            <div class="wrap-label">
                                <label for="" class="new-label-upload">
                                    <b-spinner v-if="isLoadingSaveVideo" small></b-spinner>
                                    <span v-else>{{ label_video }}</span>
                                </label>
                                <div class="wrap-btn-dropdown">
                                    <!-- <button type="button" class="btn-dropdown" @click="$bvModal.show('upload-video')" v-if="widthScreen < 600">Upload Video</button> -->
                                    <dropdown>
                                        <template slot="toggler">
                                            <button type="button" class="btn-dropdown">Pilih Video</button>
                                        </template>
                                        <dropdown-content class="content-dropdown">
                                            <div class="item-dropdown my-1 px-2 py-1" @click="$bvModal.show('upload-video')">
                                                Upload Video
                                            </div>
                                            <div class="item-dropdown my-1 px-2 py-1" @click="takeFoto('record')">
                                                Rekam Video
                                            </div>
                                            <!-- <div class="item-dropdown my-1 px-2 py-1" @click="openRecordVideo">
                                                Rekam Video
                                            </div> -->
                                        </dropdown-content>
                                    </dropdown>
                                </div>
                            </div>
                            <div v-if="$v.file.video_file.$error">
                                <div class="error size-image" v-if="!$v.file.video_file.required">
                                    Upload NPWP tidak boleh kosong
                                </div>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="label-file">Referral Code</label>
                            <input
                                type="text"
                                class="form-input"
                                v-model="form.referral_code"
                                minlength="8"
                                maxlength="8"
                                :class="{ 'form-input-succes': messageReveral == '00' }"
                            />
                            <div class="check-list"></div>
                            <div class="error">
                                <span v-if="messageReveral == 422">
                                    Minimal 8 karakter
                                </span>
                                <span v-else-if="messageReveral == 2017">
                                    Kode Reveral Salah
                                </span>
                            </div>
                        </div>
                        <p class="sub-title-validasi"></p>
                        <div class="wrap-camp">
                            <div class="picture">
                                <p>Upload Tanda Tangan Pribadi</p>
                                <div class="img-tanda-tangan">
                                    <img :src="newImage" alt="" />
                                </div>
                                <div type="button" class="take-pict" @click="(tanda = !tanda), (modalShow = 1)">
                                    Ambil tanda tangan
                                </div>
                                <div class="error size-image" v-if="message == 406">
                                    Tanda Tangan tidak boleh kosong
                                </div>
                            </div>

                            <div class="picture-parter" v-show="form.marital_status == 'Menikah'">
                                <p>Upload Tanda Tangan Suami/Istri(Opsional)</p>
                                <div class="img-tanda-tangan">
                                    <img :src="newImagePartner" alt="" />
                                </div>
                                <div type="button" class="take-pict" @click="(tanda = !tanda), (modalShow = 2)">
                                    Ambil tanda tangan
                                </div>
                            </div>

                            <div class="self-modal" v-show="tanda">
                                <div class="content-modal">
                                    <div class="title-modal">
                                        <span class="show-content" :class="{ modalActive: modalShow == 1 }">Tanda Tangan Pribadi</span>
                                        <span class="show-content" :class="{ modalActive: modalShow == 2 }">Tanda Tangan Suami/Istri</span>
                                        <span class="show-content" :class="{ modalActive: modalShow == 3 }">Video Pernyataan</span>
                                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="tanda = false">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div class="body-modal">
                                        <div v-show="modalShow == 1" style="width:300px; margin: 0 auto">
                                            <div id="sketch">
                                                <canvas id="paint"></canvas>
                                            </div>
                                            <div type="button" class="take-clear" @click="clear">
                                                Clear
                                            </div>
                                            <div type="button" class="take-save" @click="save">
                                                Save
                                            </div>
                                        </div>
                                        <div v-show="modalShow == 2" style="width:300px; margin: 0 auto">
                                            <div id="sketchPartener">
                                                <canvas id="partnerSignature"></canvas>
                                            </div>
                                            <div type="button" class="take-clear" @click="clear">
                                                Clear
                                            </div>
                                            <div type="button" class="take-save" @click="save">
                                                Save
                                            </div>
                                        </div>
                                    </div>
                                    <div class="footer-modal"></div>
                                </div>
                            </div>
                            <b-modal id="upload-video">
                                <div class="text-center">
                                    <p class="sub-title-modal">
                                        Upload video dengan membaca kalimat dibawah ini :
                                    </p>
                                    <p class="modal-statement">
                                        Saya Atas nama {{ print.fullname }} dengan Nomor KTP {{ print.ktp }} menyatakan bahwa telah sepenuhnya membaca, mengerti,
                                        serta memahami semua ketentuan dalam Pialang Perdagangan Berjangka Komoditi.
                                    </p>
                                </div>
                                <div class="form-group text-center">
                                    <label for="inputTag" class="upload-video">
                                        <b-icon icon="upload" class="mr-1 icon-upload"></b-icon> Choose File
                                        <input id="inputTag" type="file" accept="video/*" ref="uploadVideoFile" @change="uploadVideo" />
                                    </label>
                                    <br />
                                    <div v-if="loadDataVideo">
                                        <b-spinner small variant="ligth"></b-spinner>
                                        <p>upload berjalan</p>
                                    </div>
                                    <span id="imageName"></span>
                                    <div style="color: #e74c3c;font-size: 13px;padding: 15px;" v-show="statusImg == 10">
                                        File tidak boleh kosong
                                    </div>

                                    <div style="color: #e74c3c;font-size: 13px;padding: 15px;" v-show="statusImg == 11">
                                        Format file salah
                                    </div>
                                </div>
                                <small
                                    ><div class="warning-size">
                                        <b-icon icon="info-fill" class="info-warning"></b-icon>
                                        Pastikan format file .mp4 dan maksimal 200mb
                                    </div></small
                                >
                                <template #modal-footer>
                                    <button type="button" class="capture-save" @click="handleSubmitVideo">
                                        Submit
                                    </button>
                                </template>
                            </b-modal>
                            <b-modal ref="my-modal" hide-footer title="Video Pernyataan" @close="handleClose">
                                <div class="d-block text-center">
                                    <p class="sub-title-modal">
                                        Rekam video dengan membaca kalimat dibawah ini :
                                    </p>
                                    <p class="modal-statement">
                                        Saya Atas nama {{ print.fullname }} dengan Nomor KTP {{ print.ktp }} menyatakan bahwa telah sepenuhnya membaca, mengerti,
                                        serta memahami semua ketentuan dalam Pialang Perdagangan Berjangka Komoditi.
                                    </p>
                                    <b-spinner label="Loading..." v-show="loadingVideo"></b-spinner>
                                    <div class="video" v-show="!message">
                                        <video class="feed" id="recordVideo" muted="muted" autoplay></video>
                                    </div>
                                    <div class="video-result" v-show="videoResult != ''">
                                        <p>Hasil Rekam Video</p>
                                        <video :src="videoResult" controls class="feed"></video>
                                    </div>
                                    <b-alert :show="message" variant="danger">{{ message }}</b-alert>
                                </div>
                                <div class="wrap_button">
                                    <button type="button" class="capture" @click="recordVideo" v-show="btnCapture == true">
                                        Rekam Video
                                    </button>
                                    <button type="button" class="capture-save" @click="endRecordVideo" v-show="btnCapture == false && videoResult == ''">
                                        Selesai
                                    </button>
                                    <button type="button" class="capture" @click="recordVideo" v-show="videoResult != ''">
                                        Rekam Ulang Video
                                    </button>
                                    <button type="button" class="capture-save" @click="saveRecord" v-show="videoResult != ''">
                                        Simpan
                                    </button>
                                </div>
                            </b-modal>

                            <b-modal ref="capture-foto" hide-footer title="Foto Selfie">
                                <video autoplay class="feed" id="recordVideo"></video>
                                <button type="button" class="capture" @click="captureFoto" v-show="imageBase64 == ''">Ambil Foto</button>
                                <div class="mt-3" v-show="imageBase64 != ''">
                                    <h6>Hasil</h6>
                                    <canvas ref="fotoSelfie"></canvas>
                                    <div class="wrap_button">
                                        <button class="capture" @click="imageBase64 = ''">Ambil Ulang</button>
                                        <button type="button" class="capture-save" @click="saveCapture">
                                            Simpan
                                        </button>
                                    </div>
                                </div>
                            </b-modal>
                        </div>
                        <div class="penutup">
                            <div class="title-penutup">
                                PERNYATAAN KEBENARAN DAN TANGGUNG JAWAB
                            </div>
                            <div class="content-penutup">
                                Dengan mengisi kolom “YA” dibawah ini, saya menyatakan bahwa semua informasi dan semua dokumen yang saya lampirkan dalam APLIKASI
                                PEMBUKAAN REKENING TRANSAKSI SECARA ELEKTRONIK ONLINE adalah benar dan tepat. Saya akan bertanggungjawab penuh apabila dikemudian
                                hari terjadi sesuatu hal sehubungan dengan ketidak benaran data yang saya berikan.
                            </div>

                            <div class="pernyataan">
                                <div class="label">Pernyataan Kebenaran dan Tanggung Jawab</div>
                                <div class="wrap-radio-input">
                                    <div class="radio-input">
                                        <input type="radio" name="radios" id="1" :value="true" v-model="form.has_confirm_attachment" required />
                                        <label class="label-radio" for="">
                                            Ya
                                        </label>
                                    </div>
                                    <div class="radio-input">
                                        <input type="radio" name="radios" id="2" :value="false" v-model="form.has_confirm_attachment" /><label
                                            class="label-radio"
                                            for=""
                                            >Tidak</label
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="pernyataan">
                                <div class="label">Menyatakan Pada Tanggal</div>
                                <div>
                                    {{ currentDate | formatDateTime }}
                                </div>
                            </div>
                        </div>
                        <div class="button">
                            <router-link to="/register-datarekening"><button class="btn-scondary">Sebelumnya</button></router-link>
                            <button type="submit" class="btn-primer" :disabled="!form.has_confirm_attachment" v-if="form.has_confirm_attachment">
                                <div v-show="loading == false">Selanjutnya</div>
                                <Loader class="loading" v-show="loading" />
                            </button>
                            <span class="d-inline-block" tabindex="0" v-b-tooltip.top title="Pernyataan Kebenaran harus disetujui" v-else>
                                <b-button class="btn-primer" style="pointer-events: none;" :disabled="!statementUser">Selanjutnya</b-button>
                            </span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import SignaturePad from "signature_pad";
import Loader from "../assets/Loading";
import html2canvas from "html2canvas";
import * as JsPDF from "jspdf";
import { required } from "vuelidate/lib/validators";
import Dropdown from "./dropdown/Dropdown.vue";
import DropdownContent from "./dropdown/DropdownContent.vue";
import HeadRegister from "./component/HeadRegister.vue";
// import ffmpeg from "fluent-ffmpeg";
export default {
    components: {
        Loader,
        Dropdown,
        DropdownContent,
        HeadRegister,
    },
    data() {
        return {
            tanda: false,
            selected: "",
            setuju2: "",
            setuju3: "",
            setuju4: "",
            setuju5: "",
            gofx: "",
            kodeAkses: "",
            jfx: "",
            modalShow: "",
            idCustomer: "",
            form: {
                ktp: "",
                photo_with_ktp: "",
                npwp: "",
                kk: "",
                photo: "",
                signature: "",
                partner_signature: "",
                statement_video: "",
                other: "",
                has_confirm_attachment: false,
                referral_code: "",
                bank_statement: "",
                step: "attactment",
            },

            file: {
                electricity_bill_file: "",
                cc_account_file: "",
                bank_account_file: "",
                ktp_file: "",
                recent_photo_file: "",
                pict_with_ktp_file: "",
                video_file: "",
                file_npwp: "",
            },

            print: {
                fullname: "",
                alamat: "",
                telepone: "",
                ktp: "",
                pekerjaan: "",
                tandaTangan: null,
                noKantor: "",
                company_id: "",
                namaPejabat: "",
                jabatan: "",
                jabatanNasabah: "",
                no_ac_demo: "",
                tempat_ttd: "",
                complement: "",
                tanggalLahir: "",
                tempat_lahir: "",
                platform: [],
            },

            label_kk: "Upload foto kartu keluarga",
            label_cc: "Upload foto rekening kartu",
            label_listrik: "Upload rekening listrik/telepon",
            label_rekBank: "Uplaad rekening koran bank",
            label_ktp: "Upload foto/scan ktp",
            label_npwp: "Upload foto/scan npwp",
            label_terkini: "Upload foto terkini, pastikan gambar wajah  terlihat jelas",
            label_foto_Ktp: "Upload foto anda memagang KTP beserta wajah anda",
            label_video: "Upload video anda dengan kalimat yang sudah tercantum",

            // toggleOpen:false,
            btnCapture: false,
            imageBase64: "",
            statusVideo: "",
            pad: null,
            cimb: null,
            newImage: null,
            loading: false,
            newImagePartner: null,
            padPartner: null,
            statusImg: 0,
            blobs_recorded: [],
            mediaStream: [],
            mediaRecord: "",
            videoResult: "",
            message: null,
            loadingVideo: false,
            messageReveral: "",
            vidoe_type: "",
            loadDataVideo: false,
            dataVideo: null,
            loadingKtp: false,
            loadingNpwp: false,
            loadingPict: false,
            loadingPicKtp: false,
            loadingRekBank: false,
            loadingKK: false,
            loadingRek: false,
            dataPlatform: [],
            widthScreen: "",
            currentDate: "",
            statementUser: Boolean,
            isLoadingSaveVideo: false,
        };
    },
    validations: {
        file: {
            ktp_file: {
                required,
            },
            recent_photo_file: {
                required,
            },
            pict_with_ktp_file: {
                required,
            },
            file_npwp: {
                required,
            },
            video_file: {
                required,
            },
            bank_statement: {
                required,
            },
            other: {
                required,
            },
        },
        pad: {
            required,
        },
    },
    computed: {
        customerId() {
            return this.$store.getters.customerData._id;
        },
    },
    mounted() {
        this.widthScreen = screen.width;
        this.currentDate = new Date();
        axios.get("/v2/user/profile").then((res) => {
            this.print.platform = res.data.data.user.platform;
        });
        this.$store.dispatch("getCustomer").then((res) => {
            this.idCustomer = res._id;
            let dataAddress = res.identity_address;
            let platform = res.platform;

            for (let i = 0; i < platform.length; i++) {
                this.dataPlatform.push(platform[i].code);
            }

            this.print.fullname = res.fullname;
            this.print.ktp = res.ktp_no;
            this.print.telepone = res.phonenumber;
            this.print.tempat_ttd = res.identity_address.regency;
            this.print.tanggalLahir = res.date_of_birth;
            this.print.tempat_lahir = res.place_of_birth;
            this.print.alamat =
                dataAddress.address +
                " Kel. " +
                dataAddress.village +
                " Kec. " +
                dataAddress.district +
                " " +
                dataAddress.regency +
                " " +
                dataAddress.province +
                ", " +
                dataAddress.postcode;
            axios.get("/v2/kyc/attachment/" + this.idCustomer).then((res) => {
                let attachment = res.data.data.attachment;

                if (attachment) {
                    this.label_ktp = attachment.ktp.split("/").pop();
                    this.label_npwp = attachment.npwp.split("/").pop();
                    this.label_terkini = attachment.photo.split("/").pop();
                    this.label_foto_Ktp = attachment.photo_with_ktp.split("/").pop();
                    this.label_kk = attachment.kk.split("/").pop();
                    this.label_listrik = attachment.other.split("/").pop();
                    this.label_video = attachment.statement_video.split("/").pop();
                    this.label_rekBank = attachment.bank_statement.split("/").pop();

                    this.form.ktp = attachment.ktp;
                    this.form.npwp = attachment.npwp;
                    this.form.photo = attachment.photo;
                    this.form.photo_with_ktp = attachment.photo_with_ktp;
                    this.form.kk = attachment.kk;
                    this.form.other = attachment.other;
                    this.form.statement_video = attachment.statement_video;
                    this.form.bank_statement = attachment.bank_statement;
                    this.form.has_confirm_attachment = attachment.has_confirm_attachment;

                    this.$store.dispatch("getImageAccess", attachment.signature).then((res) => {
                        this.newImage = res;
                        this.print.tandaTangan = this.newImage;
                    });
                    this.form.signature = attachment.signature;
                }
            });
        });

        var canvasPribadi = document.getElementById("paint");
        var canvas = document.getElementById("partnerSignature");

        this.pad = new SignaturePad(canvasPribadi, {
            onEnd: () => {
                this.$emit("input", this.pad.toDataURL());
            },
        });
        this.padPartner = new SignaturePad(canvas, {
            onEnd: () => {
                this.$emit("input", this.padPartner.toDataURL());
            },
        });
    },
    methods: {
        cekReveral(event) {
            let reveral = event.target.value;
            if (reveral.length >= 7) {
                this.messageReveral = "";
                axios.get("/v1/nasabah/referral_code/" + reveral).then((res) => {
                    let status = res.data.data.status_code;
                    if (status == 2017) {
                        this.messageReveral = status;
                    } else if (status == "00") {
                        this.messageReveral = "00";
                    }
                });
            } else {
                this.messageReveral = 422;
            }
        },
        async convertUrlToFile(url) {
            const res = await fetch(url);
            const data = await res.blob();
            const fileNeme = url.split("/").pop();
            const metadata = { type: `image/jpg` };
            const file = new File([data], fileNeme, metadata);
            return file;
        },
        aprroveStatment(event) {
            if (event == 3) {
                this.selected = !this.selected;
                this.setuju3 = event;
                this.message = "";
            } else if (event == 4) {
                this.selected = !this.selected;
                this.setuju4 = event;
            } else if (event == 5) {
                this.selected = !this.selected;
                this.setuju5 = event;
            } else if (event == 6) {
                this.selected = !this.selected;
                this.gofx = event;
            } else if (event == 7) {
                this.selected = !this.selected;
                this.kodeAkses = event;
            } else {
                this.selected = !this.selected;
                this.jfx = event;
            }
            document.getElementById("modal").scrollTop = 0;
        },
        submitFormCimb() {
            this.setuju2 = 2;
            this.selected = !this.selected;
            var data = document.getElementById("formBiz");
            html2canvas(data).then((canvas) => {
                var margin = 7;
                var imgWidth = 210 - 2 * margin;
                var pageHeight = 295;
                var imgHeight = (canvas.height * imgWidth) / canvas.width;
                var heightLeft = imgHeight;
                let img = canvas.toDataURL("image/png");

                let pdf = new JsPDF("p", "mm");
                var position = 0;
                pdf.addImage(img, "JPEG", 20, 20);
                heightLeft -= pageHeight;
                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(img, "PNG", margin, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                this.cimb = pdf.output("formCimb.pdf");
            });
        },
        clear() {
            var canvasPribadi = document.getElementById("paint");
            this.pad = new SignaturePad(canvasPribadi, {
                onEnd: () => {
                    this.$emit("input", this.pad.toDataURL());
                },
            });
            this.pad.clear();
            var canvas = document.getElementById("partnerSignature");

            this.padPartner = new SignaturePad(canvas, {
                onEnd: () => {
                    this.$emit("input", this.padPartner.toDataURL());
                },
            });
            this.padPartner.clear();
        },
        save() {
            var canvas;
            if (this.modalShow == 1) {
                canvas = document.getElementById("paint");
            } else if (this.modalShow == 2) {
                canvas = document.getElementById("partnerSignature");
            }
            var fileUrl = canvas.toDataURL();
            let blob = atob(fileUrl.split(",")[1]);
            let array = [];
            for (let i = 0; i < blob.length; i++) {
                array.push(blob.charCodeAt(i));
            }
            this.tanda = !this.tanda;
            if (this.modalShow == 1) {
                this.newImage = fileUrl;
                this.pad = new Blob([new Uint8Array(array)], { type: "image/jpeg" });
                this.requestFormData(this.pad).then((res) => {
                    this.form.signature = res.data.data;
                });
            } else if (this.modalShow == 2) {
                this.padPartner = new Blob([new Uint8Array(array)], {
                    type: "image/jpeg",
                });
                this.requestFormData(this.padPartner).then((res) => {
                    this.form.partner_signature = res.data.data;
                });
                this.newImagePartner = fileUrl;
            }

            this.print.tandaTangan = this.newImage;
        },
        async getConnectedDevices(type) {
            const device = await navigator.mediaDevices.enumerateDevices();
            return device.filter((device) => device.kind === type);
        },

        async openCamera(cameraId, minWidth, minHeight) {
            const constraint = {
                audio: { echoCancellation: true },
                video: {
                    deviceId: cameraId,
                    width: { min: minWidth },
                    height: { min: minHeight },
                    facingMode: { exact: "user" },
                },
            };
            return await navigator.mediaDevices.getUserMedia(constraint);
        },

        async openRecordVideo() {
            this.$refs["my-modal"].show();
            this.statusVideo = 0;
            this.btnCapture = true;
            this.loadingVideo = true;
            try {
                const cameras = await this.getConnectedDevices("videoinput");
                if (cameras && cameras.length > 0) {
                    const stream = await this.openCamera(cameras[0].deviceId, 1280, 720);
                    const videoElement = document.querySelector("#recordVideo");
                    this.mediaStream = stream.getTracks();
                    videoElement.srcObject = stream;
                    let options;
                    if (MediaRecorder.isTypeSupported("video/mp4")) {
                        options = { mimeType: "video/mp4", videoBitsPerSecond: 1000000 };
                    } else {
                        options = { mimeType: "video/webm" };
                    }
                    this.mediaRecord = new MediaRecorder(stream, options);
                    this.mediaRecord.ondataavailable = (e) => {
                        videoElement.play();
                        this.blobs_recorded.push(e.data);
                    };
                    this.loadingVideo = false;
                } else {
                    alert("Camera not found");
                }
            } catch (error) {
                console.log(error);
            }
        },

        handleClose() {
            this.mediaStream.forEach((track) => {
                track.stop();
            });
        },
        takeFoto(type) {
            this.vidoe_type = type;
            let constraint;
            if (type == "record") {
                this.$refs["my-modal"].show();
                constraint = {
                    video: {
                        facingMode: "user",
                        frameRate: 24,
                        width: {
                            min: 640,
                            ideal: 780,
                            max: 1000,
                        },
                        height: {
                            min: 360,
                            ideal: 420,
                            max: 1080,
                        },
                    },
                    audio: true,
                };
            } else {
                this.$refs["capture-foto"].show();
                constraint = {
                    video: {
                        width: {
                            min: 640,
                            ideal: 780,
                            max: 1000,
                        },
                        height: {
                            min: 360,
                            ideal: 420,
                            max: 1080,
                        },
                        facingMode: "user",
                    },
                };
            }

            this.statusVideo = 0;
            this.btnCapture = true;
            this.loadingVideo = true;

            navigator.mediaDevices
                .getUserMedia(constraint)
                .then((stream) => {
                    this.loadingVideo = false;
                    const videoPlayer = document.querySelector("#recordVideo");
                    videoPlayer.setAttribute("autoplay", "");
                    videoPlayer.setAttribute("muted", "");
                    videoPlayer.setAttribute("playsinline", "");
                    var mediaStream = stream;
                    this.mediaStream = stream.getTracks();
                    videoPlayer.srcObject = stream;
                    var options = {};
                    if (MediaRecorder.isTypeSupported("video/mp4")) {
                        options = { mimeType: "video/mp4", videoBitsPerSecond: 1000000 };
                    } else if (MediaRecorder.isTypeSupported("video/webm;codecs=VP8")) {
                        options = { mimeType: "video/webm;codecs=VP9" };
                    } else {
                        options = { mimeType: "video/webm" };
                    }

                    this.mediaRecord = new MediaRecorder(mediaStream, options);
                    this.mediaRecord.ondataavailable = (e) => {
                        console.log(e.data);
                        this.blobs_recorded.push(e.data);
                    };
                })
                .catch((error) => {
                    this.loadingVideo = false;
                    this.message = error.message;
                });
        },
        recordVideo() {
            this.videoResult = "";
            this.blobs_recorded = [];
            this.mediaRecord.start(1000);
            this.btnCapture = false;
        },
        saveRecord() {
            this.isLoadingSaveVideo = true;
            let local_video = new Blob(this.blobs_recorded, { type: "video/mp4" });
            this.label_video = this.print.fullname + "." + local_video.type.slice(6, local_video.type.length);
            const newFileVideo = new File([local_video], this.label_video, { type: "video/mp4" });
            this.file.video_file = local_video;
            this.requestFormData(newFileVideo).then((res) => {
                this.form.statement_video = res.data.data;
                this.isLoadingSaveVideo = false;
            });
            this.mediaStream.forEach((track) => {
                track.stop();
            });
            this.$refs["my-modal"].hide();
            this.videoResult = "";
        },
        saveCapture() {
            let capture_img = this.imageBase64;
            var pos = capture_img.indexOf(";base64,");
            var type = capture_img.substring(5, pos);
            var buffer = atob(capture_img.replace(/^data:image\/(png|jpg);base64,/, ""));

            let result_capture = new Blob([buffer], { type: type });
            this.$refs["capture-foto"].hide();
            this.imageBase64 = "";
            this.requestFormData(result_capture).then((res) => {
                console.log(res);
            });
        },
        endRecordVideo() {
            this.videoResult = URL.createObjectURL(new Blob(this.blobs_recorded, { type: "video/mp4" }));
            this.mediaRecord.stop();
        },
        captureFoto() {
            this.openPicture = true;
            let ratio = window.innerHeight < window.innerWidth ? 16 / 9 : 9 / 16;
            const getPict = this.$refs.fotoSelfie;
            getPict.width = 465;
            getPict.height = 465 / ratio;
            const ctx = getPict.getContext("2d");
            // const videoPlayer = document.querySelector("video");

            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(document.querySelector("video"), 0, 0, getPict.width, getPict.height);

            let image = getPict.toDataURL();

            this.imageBase64 = image;
        },
        BioVerification() {
            let dateSend = moment(this.form.birthday).format("YYYY-MM-DD");
            let data = {
                nik: this.form.identity_owner,
                name: this.form.full_name,
                birthplace: this.form.place_of_birth,
                birthdate: dateSend,
                address: this.form.address,
                selfie_photo: this.imageBase64,
            };
            axios
                .post("/v1/user/data_verification", data)
                .then((res) => {
                    this.statusVideo = res.data.status;
                })
                .catch((eror) => {
                    let data = eror.response;
                    this.statusVideo = data.status;
                });
        },
        onFileKK() {
            const bank = this.$refs.bank.files[0];
            this.loadingKK = true;
            if (bank.type == "image/jpeg" || bank.type == "image/jpg" || bank.type == "image/png") {
                this.label_kk = bank.name;
                this.file.bank_account_file = bank;
                this.statusImg = 200;
                this.requestFormData(bank).then((res) => {
                    this.form.kk = res.data.data;
                    this.loadingKK = false;
                });
            } else {
                this.statusImg = 5;
                this.loadingKK = false;
            }
        },
        onFileRekBank() {
            const bill_file = this.$refs.rekBank.files[0];
            this.loadingRekBank = true;
            if (bill_file.type == "image/jpeg" || bill_file.type == "image/jpg" || bill_file.type == "image/png") {
                // this.file.electricity_bill_file = bill_file;
                this.label_rekBank = bill_file.name;
                this.statusImg = 200;
                this.requestFormData(bill_file).then((res) => {
                    this.loadingRekBank = false;
                    this.form.bank_statement = res.data.data;
                });
            } else {
                this.statusImg = 6;
                this.loadingRekBank = false;
            }
        },
        onFileRek() {
            const bill_file = this.$refs.listrik.files[0];
            this.loadingRek = true;
            if (bill_file.type == "image/jpeg" || bill_file.type == "image/jpg" || bill_file.type == "image/png") {
                this.file.electricity_bill_file = bill_file;
                this.label_listrik = bill_file.name;
                this.statusImg = 200;
                this.requestFormData(bill_file).then((res) => {
                    this.loadingRek = false;
                    this.form.other = res.data.data;
                });
            } else {
                this.statusImg = 6;
                this.loadingRek = false;
            }
        },
        onFileKTP() {
            // this.form.ktp_pict = "";
            this.label_ktp = "";
            const ktp = this.$refs.ktp.files[0];
            this.loadingKtp = true;
            if (ktp.type == "image/jpeg" || ktp.type == "image/jpg" || ktp.type == "image/png") {
                this.file.ktp_file = ktp;
                this.label_ktp = ktp.name;
                this.statusImg = 200;
                this.requestFormData(ktp).then((res) => {
                    this.loadingKtp = false;
                    this.form.ktp = res.data.data;
                });
            } else {
                this.loadingKtp = false;
                this.statusImg = 1;
            }
        },
        onFileNPWP() {
            const npwp = this.$refs.npwp.files[0];
            this.loadingNpwp = true;
            if (npwp.type == "image/jpeg" || npwp.type == "image/jpg" || npwp.type == "image/png") {
                this.file.file_npwp = npwp;
                this.label_npwp = npwp.name;
                this.statusImg = 200;
                this.requestFormData(npwp).then((res) => {
                    this.loadingNpwp = false;
                    this.form.npwp = res.data.data;
                });
            } else {
                this.statusImg = 2;
                this.loadingNpwp = false;
            }
        },
        onFileterkini() {
            const recent_photo = this.$refs.terkini.files[0];
            this.loadingPict = true;
            if (recent_photo.type == "image/jpeg" || recent_photo.type == "image/jpg" || recent_photo.type == "image/png") {
                this.file.recent_photo_file = recent_photo;
                this.label_terkini = recent_photo.name;
                this.statusImg = 200;
                this.requestFormData(recent_photo).then((res) => {
                    this.loadingPict = false;
                    this.form.photo = res.data.data;
                });
            } else {
                this.loadingPict = false;
                this.statusImg = 3;
            }
        },
        onFileKTPterkini() {
            const self_ktp = this.$refs.diri_ktp.files[0];
            this.loadingPicKtp = true;
            if (self_ktp.type == "image/jpeg" || self_ktp.type == "image/jpg" || self_ktp.type == "image/png") {
                this.statusImg = 200;
                this.requestFormData(self_ktp).then((res) => {
                    this.loadingPicKtp = false;
                    this.file.pict_with_ktp_file = self_ktp;
                    this.label_foto_Ktp = self_ktp.name;
                    this.form.photo_with_ktp = res.data.data;
                });
            } else {
                this.statusImg = 4;
                this.loadingPicKtp = false;
            }
        },
        onFilevideo() {
            const vidio = this.$refs.video.files[0];
            this.file.video_file = vidio;
            this.label_video = vidio.name;
            this.requestFormData(vidio).then((res) => {
                this.form.statement_video = res.data.data;
                // console.log(res);
            });
        },
        uploadVideo() {
            this.statusImg = "";
            const fileVideo = this.$refs.uploadVideoFile.files[0];
            if (fileVideo.type == "video/mp4" || fileVideo.type == "video/quicktime") {
                this.statusImg = "";
                this.dataVideo = fileVideo;
                this.loadDataVideo = true;
                this.requestFormData(fileVideo)
                    .then((res) => {
                        let imageName = document.getElementById("imageName");
                        imageName.innerText = fileVideo.name;
                        if (res.status == 200) {
                            this.loadDataVideo = false;
                            this.label_video = fileVideo.name;
                            this.form.statement_video = res.data.data;
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loadDataVideo = false;
                    });
            } else {
                this.statusImg = 11;
            }
        },
        handleSubmitVideo() {
            if (this.dataVideo) {
                this.$bvModal.hide("upload-video");
            } else {
                this.statusImg = 10;
            }
        },
        async requestFormData(file) {
            let formData = new FormData();
            formData.append("file", file);
            return axios.post("/v2/kyc/upload/" + this.idCustomer, formData);
        },
        registerKYC() {
            console.log(this.form);
            console.log(this.form.signature == "" ||
                this.form.ktp == "" ||
                this.form.photo_with_ktp == "" ||
                this.form.photo == "" ||
                this.form.statement_video == "" ||
                this.form.other == "" ||
                this.form.bank_statement == "");
            if (
                this.form.signature == "" ||
                this.form.ktp == "" ||
                this.form.photo_with_ktp == "" ||
                this.form.photo == "" ||
                this.form.statement_video == "" ||
                this.form.other == "" ||
                this.form.bank_statement == ""
            ) {
                this.$toast.error("Pastikan semua inputan sudah terisi");
            }
             else {
                this.message = "";
                this.loading = true;
                axios
                    .put("/v2/kyc/attachment/" + this.idCustomer, this.form)
                    .then((res) => {
                        let status = res.data.data.status_code;
                        if (status == "00") {
                            this.$router.push("/disclosure2");
                        } else if (status == "2004") {
                            this.loading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>Data sudah di submit</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        } else {
                            this.loading = false;
                            this.$notify({
                                group: "foo",
                                title: "<h5>kesalahan sistem</h5>",
                                type: "error",
                                duration: 2000,
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                        this.$notify({
                            group: "foo",
                            title: "Cek kembali inputan anda",
                            type: "error",
                            duration: 2000,
                        });
                    });
            }
        },
        modalTop() {
            // this.$refs.modal.scrollTop = 0
            // console.log('berhasil')
        },
    },
};
</script>
<style scoped>
#inputTag {
    display: none;
}

.content-dropdown {
    z-index: 1;
}

.item-dropdown {
    cursor: pointer;
}

.item-dropdown:hover {
    background: #f2f2f2;
}

.upload-video {
    border: 1px solid #1f354a;
    padding: 0.5rem;
    color: #1f354a;
    border-radius: 5px;
    font-size: 13px;
    cursor: pointer;
    font-weight: bold;
}

.upload-video:hover {
    background: #1f354a;
    color: #ffffff;
}

.icon-upload {
    font-size: 19px;
}

.error {
    margin-left: 195px;
}

.container-outline {
    width: 70%;
}

.li-active:nth-child(9)::before {
    border: dashed 1px #c59733;
}

.wrap_button {
    display: flex;
    justify-content: space-between;
}
p span {
    text-transform: capitalize;
    font-weight: bold;
}
.img-tanda-tangan {
    width: 302px;
    height: 152px;
    border: solid 1px #dddddd;
}

.img-tanda-tangan img {
    height: 100%;
}

.wrap-radio-input {
    display: flex;
}

.radio-input {
    display: flex;
    align-items: center;
}

.tooltip-wrapper {
    display: inline-block; /* display: block works as well */
    margin: 50px; /* make some space so the tooltip is visible */
}

#paint {
    border: 1px solid #dddddd;
    /* background : #333333;  */
    margin-left: auto;
    margin-right: auto;
    display: block;
}

#partnerSignature {
    border: 1px solid #dddddd;
    /* background : #333333;  */
    margin-left: auto;
    margin-right: auto;
    display: block;
}

.wrap-label {
    width: 73%;
    position: relative;
}

.wrap-btn-dropdown {
    position: absolute;
    top: 0;
    right: 0;
    /* z-index: 2; */
}

.title-modal {
    font-size: 20px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 33px;
}

.clickCheck {
    width: 17px;
    height: 20px;
    position: absolute;
    top: -7px;
    left: -2px;
    z-index: 3;
    cursor: pointer;
}

.penutup {
    font-weight: normal;
    font-size: 14px;
    margin-bottom: 2rem;
}

.title-penutup {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
}

.sentence-video {
    font-size: 12.5px;
    margin: 15px 0 15px 24%;
}

.sentence-video p {
    color: #594bd6;
}

.form-video {
    padding: 10px;
    background-color: rgb(251, 100, 0, 0.1);
    z-index: 0;
    border-radius: 10px;
}

.form-success {
    border: solid 0.5px #1f354a;
    position: relative;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.form-success::after {
    content: "f00c";
    position: absolute;
    right: 0;
}

.modal-footer {
    justify-content: space-between;
}

.take-pict {
    padding: 5px 25px;
    border-radius: 10px;
    border: none;
    background-color: #c59733;
    color: white;
    width: 100%;
    text-align: center;
    margin-top: 25px;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.take-clear {
    padding: 5px 25px;
    border-radius: 10px;
    border: none;
    background-color: white;
    color: #594bd6;
    width: 40%;
    text-align: center;
    margin-top: 25px;
    border: solid 1px #594bd6;
    display: inline-block;
    margin-right: 20%;
}

.take-save {
    padding: 5px 25px;
    border-radius: 10px;
    border: none;
    background-color: #594bd6;
    color: white;
    width: 40%;
    text-align: center;
    margin-top: 25px;
    display: inline-block;
}

.wrap-camp {
    position: relative;
    display: flex;
}

.picture {
    margin-bottom: 30px;
    margin-right: 15%;
}

.picture canvas {
    border: 1px solid #dddddd;
    display: block;
}

.modal-picture {
    position: absolute;
    box-shadow: 6px 6px 12px 0 rgb(0, 0, 0, 0.35);
    width: 60%;
    height: 270px;
    padding: 20px;
    height: 420px;
    background-color: white;
    z-index: 9;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
}

.feed {
    width: 100%;
    display: block;
}

.size-image {
    margin-left: 0;
    padding: 5px;
}

.video-result {
    margin-top: 25px;
}

.video-result p {
    text-align: left;
    font-size: 15px;
}

.sub-title-modal {
    font-weight: bold;
    color: #707070;
}

.modal-statement {
    padding: 6px;
    background-color: rgba(197, 151, 51, 0.657);
    border-radius: 5px;
    color: white;
}

.capture {
    /* margin: 30px; */
    padding: 10px 25px;
    border-radius: 10px;
    border: none;
    background-color: #594bd6;
    color: white;
    text-align: center;
    outline: none;
    margin-top: 25px;
    /* float: left; */
}

.capture-save {
    padding: 10px 25px;
    border-radius: 10px;
    border: none;
    background-color: #c59733;
    color: white;
    text-align: center;
    outline: none;
    margin-top: 25px;
    /* border: 1px solid #c59733; */
}

.sub-title-validasi {
    margin: 50px 0 20px 0;
    font-size: 18px;
    font-weight: bold;
}

/* .take-foto{
    margin-top: -30px;
} */

.footer-modal .btn-primer {
    margin: 0 auto;
}

.show-content {
    display: none;
}

.modalActive {
    display: block;
}

.form-checkbox {
    font-size: 14px;
    color: #707070;
    display: flex;
}

.form-group-input {
    font-size: 14px;
}

input[type="file"] {
    border: none;
}

.input-file {
    display: none;
}

/* .input-file{
    background: transparent;
    width: 73%;
    vertical-align: middle;
} */

.label-penyelesaian {
    display: block;
}

.new-label-upload {
    position: relative;
    width: 100%;
    font-size: 13px;
    font-family: "Poppins", sans-serif;
    height: 45px;
    border-radius: 7px;
    border: none;
    background: #f8f9fe;
    color: #707070;
    padding: 12px 20px;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.button-upload {
    position: absolute;
    right: 0;
    top: 0px;
}

#dropdown-right__BV_toggle_ {
    font-size: 14px !important;
    padding: 11px 16px !important;
    border-radius: 0 10px 10px 0;
}

.label-upload {
    position: relative;
    width: 100%;
    font-size: 13px;
    font-family: "Poppins", sans-serif;
    height: 45px;
    border-radius: 7px;
    border: none;
    background: #f8f9fe;
    color: #707070;
    padding: 12px 20px;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.upload-video {
    z-index: 1;
}

.input-file ~ .label-upload:focus {
    color: #707070;
    background-color: #fff;
    border-color: #6454f0 !important;
    outline: 0;
    z-index: 3;
    box-shadow: 0 0 0 0.3rem rgba(100, 84, 240, 0.25);
}

.btn-dropdown {
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    background: #c59733;
    height: 45px;
    width: 120px;
    text-align: center;
    color: #fff;
    border-left: inherit;
    border: none;
    font-size: 15px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.btn-dropdown:focus {
    outline: none;
}

.label-upload::after {
    content: attr(data-browse);
    position: absolute;
    right: 0px;
    top: 0px;
    border-top-right-radius: 9px;
    border-bottom-right-radius: 9px;
    padding: 13px 0;
    background: #c59733;
    height: 45px;
    width: 120px;
    text-align: center;
    color: #fff;
    border-left: inherit;
    outline: none;
    font-size: 13px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}

.outer {
    margin: 10px;
    width: 17px;
    height: 17px;
}

.inner {
    width: 13px;
    height: 13px;
}

.register {
    margin: 46px 0;
}

.label-file {
    font-size: 14px;
    width: 205px;
    display: inline-block;
}

.group-file {
    display: flex;
    align-items: center;
}

.placholder {
    position: absolute;
    left: 270px;
    top: 15px;
    font-size: 14px;
    color: rgba(112, 112, 112, 0.5);
}

.placholder::after {
    content: "upload file";
}

select {
    width: 73%;
    height: 50px;
    border-radius: 10px;
    border: solid 1px #707070;
}

.tempat {
    width: 41%;
    margin: 0 25px 0 0;
}

.tanggal {
    width: 25%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}

.pos-telepon {
    width: 25%;
}

.jabatan {
    height: 35px;
    width: 10%;
}

.tahun {
    margin: 0 0 0 30px;
}

.identitas {
    width: 20%;
    margin: 0 32px 0 0;
    background-position-x: 88%;
}

.no-identitas {
    width: 50%;
}

.icon-calender {
    font-size: 20px;
    color: white;
}

.content-register {
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
    background: #ffffff;
    border-radius: 5px;
}

.title {
    font-size: 25px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    margin: 0 0 50px;
}

.pernyataan {
    display: flex;
    padding: 0 1rem;
    margin-top: 1rem;
}

.pernyataan:last-child {
    margin-top: unset;
}

.label {
    width: 20rem;
}

.label-radio {
    width: 3rem;
    margin-left: 0.6rem;
    margin-bottom: unset;
}

.navigation {
    margin: 0 0 50px;
    font-size: 10px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
}
.container {
    width: 90%;
    padding-top: 45px;
}

.nav-root {
    display: flex;
    justify-content: space-between;
    margin: 0 0 50px;
    position: relative;
}

.list-root {
    list-style: none;
    height: 65px;
    width: 40%;
    padding: 20px 15px;
    text-align: center;
    color: rgba(112, 112, 112, 0.5);
}

.active {
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    border-top: solid 2px #000e22;
    border-right: solid 2px #000e22;
    border-bottom: solid 2px #000e22;
    background-color: #1f354a;
    color: white;
    position: relative;
    text-align: center;
}

.active:first-child {
    border-top-left-radius: 15px;
}

.active:last-child {
    border-top-right-radius: 15px;
    border-bottom-right-radius: 0;
}

.active::before {
    z-index: -1;
    position: absolute;
    content: "";
    display: inline-block;
    width: 50px;
    height: 65px;
    background-color: #1f354a;
    top: -2px;
    left: -41px;
    border: 2px solid #000e22;
}

.active:first-child::before {
    opacity: 0;
}

.button {
    display: flex;
    justify-content: space-between;
    padding: 76px 15px;
}

.sub-title {
    margin: 0 0 73px;
    font-size: 18px;
    font-weight: bold;
}

.warning-size {
    font-size: 14px;
    font-weight: normal;
}

.info-warning {
    font-size: 20px;
    color: #c59733;
}

.arrow {
    margin-left: 10px;
    margin-right: 10px;
    border: solid #6454f0;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 4px;
    transform: rotate(45deg);
    vertical-align: super;
}

.wrap-arrow {
    position: absolute;
    display: inline-block;
    width: 56px;
    height: 48px;
    /* border: solid 1px; */
    right: 50px;
    top: 1px;
    border-radius: 10px;
    text-align: center;
    padding: 15px 9px;
    background: white;
}

@media (min-width: 768px) and (max-width: 1023px) {
    .list-root {
        font-size: 13px;
    }
    .active {
        padding: 10px;
        text-align: center;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .active::before {
        width: 28px;
        left: -25px;
    }

    label {
        width: 100%;
    }

    .label-upload {
        left: 0;
        width: 100%;
    }

    .label-upload::after {
        width: 115px;
        line-height: 1.9;
    }
}

@media (max-width: 768px) {
    .container-outline {
        width: 90%;
    }

    li > span {
        display: none;
    }

    .form-input,
    select,
    .input-button {
        width: 100%;
    }

    .birtday,
    .kecamatan,
    .input-rt-rw {
        width: 100% !important;
        text-align: left;
    }

    .register {
        margin: 20px 0;
    }

    .title {
        font-size: 18px;
        margin: 0 0 20px;
    }

    .sub-title {
        margin-bottom: 20px;
    }

    .top-squence {
        width: 100%;
        padding: 15px 10px;
    }

    .container {
        width: 100%;
        padding: 25px 20px;
    }

    .identitas,
    .form-ktp-bagi,
    .tanggal-aktif,
    .tempat,
    .kecamatan,
    .input-rt-rw {
        margin: 0 0 10px;
    }

    .detail-alamat,
    .rt-rw {
        margin: 0 0 0.5rem;
    }

    .form-checkbox {
        align-items: flex-start;
    }

    .label--checkbox {
        position: inherit !important;
        margin-left: 15px;
    }

    label {
        display: block;
    }

    .button {
        display: block;
        width: 100%;
        padding: 25px 20px;
        text-align: center;
    }

    .btn-scondary,
    .btn-primer {
        width: 100%;
    }

    .btn-scondary {
        margin-bottom: 20px;
    }

    .content-modal {
        width: 95%;
    }

    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .group-file {
        display: block;
    }

    .wrap-label {
        width: 100%;
    }

    .picture {
        margin-bottom: 55px;
        flex-grow: 1;
        margin-right: unset
    }

    .video {
        height: 100%;
        object-fit: contain;
    }

    .feed {
        width: 80%;
        height: 100%;
        object-fit: cover;
        margin: auto;
    }

    .pernyataan {
        flex-direction: column;
        padding: unset
    }

    .radio-input {
        margin-bottom: 1rem;
    }

    .img-tanda-tangan{
        width: 100%;
    }

    .label{
        width: unset
    }
}
</style>
